import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/comments.svg'


const _withScopeId = n => (_pushScopeId("data-v-c05374a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-3xl p-6 overflow-auto" }
const _hoisted_2 = { class: "flex flex-col justify-around h-3/4" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "font-bold text-secondary" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-dotted border-main border" }, null, -1))
const _hoisted_7 = { class: "text-sm mt-2 mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-lifebuoy text-xl mr-3" }, null, -1))
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "text-sm mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-rescue text-xl mr-3" }, null, -1))
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm flex"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "popup-icon"
}, null, -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-weather text-xl mr-3" }, null, -1))
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-marker text-xl mr-3" }, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-camera text-xl mr-3" }, null, -1))
const _hoisted_25 = {
  key: 2,
  class: "flex flex-wrap"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src", "onClick"]

import { Colors } from "@/utils/Colors"
import { store } from "@/main"
import { computed, ref } from "vue"
import { OtherData } from "@/classes/data/OtherData"
import { format } from "@formkit/tempo"


export default /*#__PURE__*/_defineComponent({
  __name: 'DeathDescription',
  setup(__props) {

const deathData = computed(() => store.getState().popUpData as OtherData)
const style = `--text-color: ${Colors.BLUE};`

function setCurrentImage (url: string) {
  store.setImageModalUrl(url)
  store.updateImageModalVisibility(true)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "popUp",
    style: style,
    class: "flex items-center justify-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(deathData.value.type), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(format)(deathData.value.date, "full")), 1),
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("popup.boatInvolved")) + ": ", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(deathData.value.boatInvolved), 1)
        ]),
        _createElementVNode("p", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("popup.peoplesNB")) + ": ", 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(deathData.value.deathNumber), 1)
        ]),
        (deathData.value.testimonySrc.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("popup.testimony")) + ": ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deathData.value.testimonySrc, (src, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "font-bold ml-2 testimony-text",
                  key: src+i
                }, [
                  _createElementVNode("a", {
                    href: src,
                    target: "_blank"
                  }, _toDisplayString(deathData.value.testimonyName[i]) + " " + _toDisplayString(i < deathData.value.testimonySrc.length -1 ? "," : ""), 9, _hoisted_15)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _hoisted_16,
        _createElementVNode("p", _hoisted_17, [
          _hoisted_18,
          _createTextVNode(_toDisplayString(_ctx.$t("popup.wind")) + ": ", 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(deathData.value.windForce ? deathData.value.windForce + _ctx.$t("popup.windUnit") : _ctx.$t("popup.unknown")), 1),
          _createTextVNode("- " + _toDisplayString(_ctx.$t("popup.waves")) + ": ", 1),
          _createElementVNode("span", _hoisted_20, _toDisplayString(deathData.value.waveHeight ? deathData.value.waveHeight + "m" : _ctx.$t("popup.unknown")), 1)
        ]),
        _createElementVNode("p", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, "Lat: " + _toDisplayString(deathData.value.latitude) + " - Lon: " + _toDisplayString(deathData.value.longitude), 1)
        ]),
        (deathData.value.imageSrc.length > 0 || deathData.value.videoSrc.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(_toDisplayString(_ctx.$t("popup.videosAndPictures")), 1)
            ]))
          : _createCommentVNode("", true),
        (deathData.value.imageSrc.length > 0 || deathData.value.videoSrc.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deathData.value.videoSrc, (url) => {
                return (_openBlock(), _createElementBlock("video", {
                  key: url,
                  class: "max-w-[50%] p-1",
                  controls: "",
                  controlsList: "nodownload"
                }, [
                  _createElementVNode("source", {
                    src: url,
                    type: "video/mp4"
                  }, null, 8, _hoisted_26)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deathData.value.imageSrc, (url) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: url,
                  class: "max-w-[50%] p-1 cursor-pointer",
                  src: url,
                  onClick: ($event: any) => (setCurrentImage(url))
                }, null, 8, _hoisted_27))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})